import React from 'react';
import { Link } from 'react-router-dom';
import styles from './TermsPage.module.css';

export default function DisclaimerPage() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Link to="/settings" className={styles.backLink}>← Back</Link>
        <h1 className={styles.title}>Medical Disclaimer</h1>
        <p className={styles.date}>Last updated: March 2026</p>
      </div>
      <div className={styles.content}>
        <section className={styles.section}>
          <h2>Not Medical Advice</h2>
          <p>beryl is a personal tracking and journaling tool designed to help you organise your recovery journey. It is not a medical device, does not provide medical advice, diagnosis, or treatment, and is not a substitute for professional medical guidance.</p>
        </section>
        <section className={styles.section}>
          <h2>Consult a Healthcare Professional</h2>
          <p>Always seek the advice of your physician, physiotherapist, or other qualified health provider with any questions you have regarding a medical condition or treatment plan. Never disregard professional medical advice or delay seeking it because of something you have read or tracked in beryl.</p>
        </section>
        <section className={styles.section}>
          <h2>Exercise &amp; Rehabilitation</h2>
          <p>The exercises shown in beryl are for reference and tracking purposes only. They should only be performed under the supervision or recommendation of a qualified healthcare professional. Performing exercises incorrectly or without appropriate guidance can result in injury or worsening of your condition.</p>
        </section>
        <section className={styles.section}>
          <h2>Pain &amp; Symptom Tracking</h2>
          <p>Pain scores, symptom notes, and other data entered into beryl are for personal tracking only. If you experience severe, worsening, or unusual symptoms, seek medical attention immediately — do not rely on beryl to assess your condition.</p>
        </section>
        <section className={styles.section}>
          <h2>Nutrition &amp; Supplements</h2>
          <p>Nutritional information and supplement suggestions within beryl are general in nature and not tailored to your individual medical needs. Consult a registered dietitian or your doctor before making significant changes to your diet or supplement regimen.</p>
        </section>
        <section className={styles.section}>
          <h2>Emergency Situations</h2>
          <p>beryl is not intended for use in medical emergencies. If you believe you are experiencing a medical emergency, call your local emergency services immediately.</p>
        </section>
        <section className={styles.section}>
          <h2>Accuracy of Information</h2>
          <p>While we strive to keep beryl's content accurate and up-to-date, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, or suitability of any information displayed in the app.</p>
        </section>
      </div>
    </div>
  );
}
